import React from 'react';
import CreativePreviewBubble from './CreativePreviewBubble';

const formatTime = (value) => {
  try {
    return new Date(value).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
};

export default function CreativeMessage({ message }) {
  const role = message?.role === 'user' ? 'user' : 'assistant';

  return (
    <article className={`creative-message creative-message--${role}`}>
      <span className="creative-message__avatar" aria-hidden="true">{role === 'assistant' ? 'AI' : 'EU'}</span>
      <div className="creative-message__body">
        {message?.content ? <p>{message.content}</p> : null}
        {role === 'assistant' ? <CreativePreviewBubble structure={message?.structure} /> : null}
        <small>{formatTime(message?.created_at || message?.createdAt)}</small>
      </div>
    </article>
  );
}
